module.exports = __webpack_public_path__ + "media/src/images/page03_zu_worksheet_01-62c5d898781dca886d72625117fae94a.png";